// Port of api/fuel/app/classes/filter/search/games/filters/post/play/plays/winpercent.php
import F from 'offline/filter/constants'
import DB from 'offline/db'
import Util from 'offline/util'
import { rangeActive } from 'offline/filter/core/search/unit'
import Helpers from 'offline/filter/core/helpers'

export default {
	name: 'post.play.plays.winpercent',
	priority: 58,
	post: true,
	require: function(config, filter) {
		return config.ownerType === F.OWNER_USER && config.resultType === F.RESULT_GAME && rangeActive(filter.play && filter.play.winpercent, 0, 100)
	},
	run: function(config, filter, data, results) {
		if (!results.index.length || !results.concat || !results.concat.p || !results.concat.p.length) return results
		var rows = DB.query(
			'SELECT game_id AS g, SUM(play_count) AS c, SUM(play_won) AS w FROM play WHERE play_result = 1 AND game_id IN(' + Util.in(results.index) + ') AND user_id = ' + config.userID + ' AND play_id IN(' + Util.in(results.concat.p) + ') GROUP BY game_id'
		)
		var wins = []
		for (var i = 0; i < rows.length; i++) {
			var c = parseInt(rows[i].c || 0, 10)
			var w = parseInt(rows[i].w || 0, 10)
			var p = c ? (100 / c) * w : 0
			if (p >= filter.play.winpercent.from && p <= filter.play.winpercent.to) {
				wins.push(parseInt(rows[i].g, 10))
			}
		}
		results.index = Helpers.preserve_sort(results.index, wins.map(function(id) { return { id: id } }), 'id').map(function(item) { return item.id })
		return results
	}
}
